import './MissionActions.scss';
import { useScreenSize } from '@custom/dx3';
import type { FormEvent } from 'react';
import { useCallback, useMemo } from 'react';
import type { MissionCategoryDisplayValue } from '../../../assets/constants/missionFiltering';
import { categories } from '../../../assets/constants/missionFiltering';

import { FiltersAsButton } from './FiltersAsButton';
import { FiltersAsDropDown } from './FiltersAsDropdowns';

type MissionActionsProps = {
  category?: string;
  setCategory: (str: MissionCategoryDisplayValue) => void;
};

export function MissionActions(props: MissionActionsProps): JSX.Element {
  const isDesktop = useScreenSize() === 'desktop';

  const onFormSubmit = useCallback((e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  }, []);

  const { category, setCategory } = props;

  const handleCategoryChange = useCallback(
    (category: string | undefined) => {
      setCategory(category as MissionCategoryDisplayValue);
    },
    [setCategory]
  );

  const FilterComponent = useMemo(() => {
    return isDesktop ? FiltersAsDropDown : FiltersAsButton;
  }, [isDesktop]);

  return (
    <div className="mission-actions">
      <FilterComponent
        onFormSubmit={onFormSubmit}
        selectedCategory={category}
        categories={categories}
        handleCategoryChange={handleCategoryChange}
      />
    </div>
  );
}
